import type { FC } from 'react';

import { Bucket, InputSelect, InputText } from '@eneco/sparky';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from './types';
import { optionsOf } from '../contact-form/options';
import type { CorrectionInvoiceFormContent } from '../correction-invoice-form-content.types';

type Props = {
  content: CorrectionInvoiceFormContent;
};

/**
 * Mirrors the legacy `components/CorrectionReason.tsx`. The select options go through `optionsOf`, which
 * hands `InputSelect` the legacy `{ label, value }` (Sanity's value is the option's `name`).
 */
export const CorrectionReason: FC<Props> = ({ content }) => {
  const {
    formFieldsCorrectionRequest_title,
    correctionMeterReadingsFormField,
    yearnoteIssueFormField,
    yearnoteIssueOtherFormField,
  } = content;

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<FormValues>();

  const selectedReason = watch('correctionReason');

  return (
    <Bucket title={formFieldsCorrectionRequest_title ?? ''}>
      <Bucket.Content>
        <InputSelect
          placeholder={yearnoteIssueFormField?.placeholder ?? ''}
          label={yearnoteIssueFormField?.label ?? ''}
          options={optionsOf(yearnoteIssueFormField)}
          {...register('correctionReason')}
          error={errors.correctionReason?.message}
        />
        {selectedReason === 'other' ? (
          <InputText
            placeholder={yearnoteIssueOtherFormField?.placeholder ?? ''}
            label={yearnoteIssueOtherFormField?.label ?? ''}
            {...register('otherCorrectionReason')}
            error={errors.otherCorrectionReason?.message}
          />
        ) : null}
        <InputSelect
          placeholder={correctionMeterReadingsFormField?.placeholder ?? ''}
          label={correctionMeterReadingsFormField?.label ?? ''}
          options={optionsOf(correctionMeterReadingsFormField)}
          {...register('changeType')}
          error={errors.changeType?.message}
        />
      </Bucket.Content>
    </Bucket>
  );
};
